module.exports = __webpack_public_path__ + "img/left-image.ca6bd50e.png";